import { Box, TypographyStylesProvider, Image } from "@mantine/core";
import React from "react";
import { IconDatabase } from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import { JsonView, allExpanded, darkStyles } from "react-json-view-lite"; // Add the missing imports
import SimpleImage from "../articlesHelpers/SimpleImage";

export const DELETING_YOUR_ACCOUNT_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Rizful Node is designed so you can quickly and easily delete your account,
      but, we won't let you delete your account if you have any nodes -- so if
      you have any nodes running or stopped, you need to{" "}
      <a href="/docs/deleting-node#deleting-your-node">delete your nodes </a>
      first.
    </p>

    <p>
      {" "}
      If you try to delete your account with any active nodes, you'll see a
      message like this:
    </p>

    <SimpleImage
      h={150}
      src="docs_images/please-delete-your-nodes-before-closing-your-account.png"
    />
    <p>
      Once you are sure all of your nodes are deleted, please proceed to the
      home page, and look for this button:
    </p>

    <SimpleImage h={400} src="docs_images/close-account-button.png" />

    <p>Hit that, and you'll have one more opportunity to confirm.....</p>

    <SimpleImage
      h={300}
      // w={356}

      src="docs_images/close-account-confirmation.png"
    />
    <p>
      And one more thing for extra credit. You can now actually confirm that
      your account is fully deleted by signing up for a NEW account with the
      SAME email address! That's totally allowed, so you can try that and see
      that gets you a totally NEW account...{" "}
    </p>
  </TypographyStylesProvider>
);
